import WOW from "../../../node_modules/wowjs/dist/wow";
export default{
    data(){
        return {
           
        }
    },
	mounted() {
		let wow = new WOW.WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 0,
			mobile: true,
			live: true
		});
		wow.init();
	}
}